import api from 'Application/api/api';

const getLibraryInstructions = (load, cancelToken = null) =>
    api.get('/education/library-instructions', {
        params: {
            load,
        },
        cancelToken,
    });

export default getLibraryInstructions;
